// Patches the fields TournamentsList.js's own scroll-restore snapshot
// (sessionStorage, key "tournamentsListCache_...") shows for one tournament,
// right when that tournament's own Information tab (or banner) saves a
// change.
//
// Without this: clicking a tournament card on главная saves that snapshot so
// coming back restores your scroll position instead of refetching page 1
// from scratch (see TournamentsList.js's CACHE_MAX_AGE_MS, 10 minutes).
// Editing the tournament's name/dates/format and then navigating back within
// that window restored the snapshot as-is - the PRE-edit card, for up to 10
// minutes, because the restore never re-fetches, it replays exactly what was
// saved before you clicked in. Looked like (and is) a caching bug.
//
import { patchedTournamentFields } from "./patchTournamentFields";

export const patchTournamentListCache = (tournamentId, fields) => {
    if (!tournamentId || !fields) return;

    for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        if (!key || !key.startsWith("tournamentsListCache_")) continue;
        try {
            const parsed = JSON.parse(sessionStorage.getItem(key));
            if (!Array.isArray(parsed?.tournaments)) continue;

            let changed = false;
            const tournaments = parsed.tournaments.map(t => {
                if (t?.id !== tournamentId) return t;
                const patch = patchedTournamentFields(t, fields);
                if (!patch) return t;
                changed = true;
                return { ...t, ...patch };
            });

            if (changed) {
                sessionStorage.setItem(key, JSON.stringify({ ...parsed, tournaments }));
            }
        } catch (e) {
            // Malformed or foreign entry under this prefix - leave it alone.
        }
    }
};

export default patchTournamentListCache;
